import {FormInstance} from 'antd/es/form';
import React, {FC} from 'react';

import {
    dynamicFieldsSorter,
} from 'components/ais/monitor-services-card/monitor-service-dynamic-fields/lib/utils';
import {
    IGNORABLE_FIELDS_KEYS,
} from 'components/ais/monitor-services-card/monitor-service-dynamic-fields/model/constants';
import {IDynamicInputField} from 'shared/types';

import {
    MonitorServiceDynamicField
} from '../monitor-service-dynamic-field/monitor-service-dynamic-field';
import s from './monitor-service-dynamic-fields.module.less';


interface IMonitorServiceDynamicFieldsProps {
    form: FormInstance;
    fields: IDynamicInputField[] | undefined;
    entityName: string;
    disabled?: boolean;
}

export const MonitorServiceDynamicFields: FC<IMonitorServiceDynamicFieldsProps> = ({
    form,
    fields,
    entityName,
    disabled = false,
}: IMonitorServiceDynamicFieldsProps) => {

    const filteredFields = fields
        ?.filter((f: any) => !IGNORABLE_FIELDS_KEYS.includes(f?.key))
        ?.sort(dynamicFieldsSorter);

    if (!filteredFields?.length) {
        return null;
    }

    return (
        <div className={s['monitor-service-fields']}>
            <div className={s['monitor-service-fields__title']}>
                Дополнительные поля
            </div>
            <div className={s['monitor-service-fields__content']}>
                {filteredFields?.map((filteredFieldMeta: IDynamicInputField) => (
                    <MonitorServiceDynamicField
                        form={form}
                        fieldMeta={filteredFieldMeta}
                        entityName={entityName}
                        disabled={disabled}
                    />
                ))}
            </div>
        </div>
    );
};
